import React from "react";
import HijriJS from "./HijriJs"
// import $, { data } from "jquery"

import _ from "lodash";

import {HariLiburNasional, HariLiburIslam, ChineseNewYear, 
    HariNyepi, JumatAgung, KenaikanIsa, Waisak} from "./hari_libur"

import "./KalenderJawa.css"


class KalenderJawa extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            judul_kalender: "", //judul
            rentan_tgl_jawa: "", //sub-judul
            daftar_hari_libur: [],
            cell_date_items: {},
            detailedDate: null,
        }

        this._TODAY = new Date();
        this.cal_bulan = this._TODAY.getMonth(); // bulan aktif di kalender (index)
        this.cal_tahun = this._TODAY.getFullYear(); // tahun aktif di kalender
    }

    namaWuku = ['Sinta', 'Landep', 'Wukir', 'Kurantil', 'Tolu', 'Gumbreg', 'Wariga alit', 
    'Wariagung', 'Julangwangi', 'Sungsang', 'Galungan', 'Kuningan', 'Langkir', 'Mandasiya', 
    'Julung pujut', 'Pahang', 'Kuru welut', 'Marakeh', 'Tambir', 'Medangkungan', 'Maktal', 
    'Wuye', 'Manahil', 'Prangbakat', 'Bala', 'Wugu', 'Wayang', 'Kulawu', 'Dukut', 'Watu Gunung'];
    
    neptu = {
        'Senin': {
            'Pon': 0xb,
            'Wage': 0x8,
            'Kliwon': 0xc,
            'Legi': 0x9,
            'Pahing': 0xd
        },
        'Selasa': {
            'Pon': 0xa,
            'Wage': 0x7,
            'Kliwon': 0xb,
            'Legi': 0x8,
            'Pahing': 0xc
        },
        'Rabu': {
            'Pon': 0xe,
            'Wage': 0xb,
            'Kliwon': 0xf,
            'Legi': 0xc,
            'Pahing': 0x10
        },
        'Kamis': {
            'Pon': 0xf,
            'Wage': 0xc,
            'Kliwon': 0x10,
            'Legi': 0xd,
            'Pahing': 0x11
        },
        'Jumat': {
            'Pon': 0xd,
            'Wage': 0xa,
            'Kliwon': 0xe,
            'Legi': 0xb,
            'Pahing': 0xf
        },
        'Sabtu': {
            'Pon': 0x10,
            'Wage': 0xd,
            'Kliwon': 0x11,
            'Legi': 0xe,
            'Pahing': 0x12
        },
        'Minggu': {
            'Pon': 0xc,
            'Wage': 0x9,
            'Kliwon': 0xd,
            'Legi': 0xa,
            'Pahing': 0xe
        }
    };
    hari = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jum\'at', 'Sabtu'];

    bulan = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", 
        "Juli", "Agustus", "September", "Oktober","November", "Desember"];

    
    getPrimbonWuku = (_tahun, _bulan, _hari) => {
        var dtPatok = new Date(2016, 0, 1), 
            dt = new Date(_tahun, _bulan - 1, _hari),
            RentangHari = Math.floor((dt - dtPatok) / 86400000), 
            A = RentangHari % 210 + 33, 
            B = A + 210, 
            idwuton = B % 210, 
            idwuku = Math['floor'](idwuton / 7);
            // idweton = idwuton % 35 % 35;

        return idwuku
    }

    
    pasaran = (y, m, d) => {
        var daftar_pasaran = ['Legi','Pahing','Pon','Wage','Kliwon'];
        var d2 = new Date("1938/1/1");
        var d1 = new Date(y +'/'+ m +'/'+ d);
        var selisih = Math.floor(Math.abs(d1-d2)/86400000);
        var pasar = daftar_pasaran[selisih%5];
        return pasar;
    }
    
    generate_table = () => {
        var _bulan = this.cal_bulan,
            _tahun = this.cal_tahun;
        
        this.setState({
            developer: "Tiang Jawi",
            developer_url: "https://tiangjawi.com",
        })
        

        // $('#calendar').hide(); //$
        // $('.cal_table tbody tr td p').empty(); //$
        // $('.cal_table tbody tr td span').empty(); //$
    
        // this.setState({
        //     cal_bulan: _bulan,
        //     cal_tahun: _tahun,
        // })
        
        var hijriDate, pasarJava, dino;

        var bulan_jawa = ['Sura', 'Sapar', 'Mulud', 'Bakda Mulud', 'Jumadilawal', 'Jumadilakir', 'Rejeb', 'Ruwah', 'Pasa', 'Sawal', 'Sela', 'Besar'
        ];
        var bulan_hijr = ['Muharam', 'Safar', 'Rabiul awal', 'Rabiul akhir', 'Jumadil awal', 'Jumadil akhir', 'Rajab', 'Syakban', 'Ramadan', 'Syawal', 'Zulkaidah', 'Zulhijah'
        ];
        var first_date = new Date(_tahun, _bulan, 1);
        var last_date = new Date(_tahun, _bulan + 1, 0);
        

        // var _0x233918 = document.querySelector('h2.title-hijr');
    
        var first_h = HijriJS.gregorianToHijri(first_date.getFullYear(), first_date.getMonth() + 1,
            first_date['getDate']());
    
        first_h = first_h.day + ' ' + bulan_jawa[first_h.month - 1] + ' ' + (
            Number(first_h['year']) + 512) + ' Ja';
    
        var last_h = HijriJS.gregorianToHijri(last_date.getFullYear(), last_date.getMonth() + 1,
            last_date['getDate']());
    
        last_h = last_h.day + ' ' + bulan_jawa[last_h.month - 1] + ' ' + (
            Number(last_h['year']) + 512) + ' Ja';
    
        this.setState({
            judul_kalender: this.bulan[this.cal_bulan] + ' ' + this.cal_tahun,
            rentan_tgl_jawa: first_h + ' - ' + last_h,
        })

        var tahun_jawa = ['Alip', 'Ehe', 'Jimawal', 'Je', 'Dal', 'Be', 'Wawu', 'Jimakir'];
    
        var max_date = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        var no_date = 1;
        var row_tbl = 0;
        var col_tbl = first_date.getDay();
    
        if (_tahun % 4 === 0) {
            max_date = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        }
    
        let _daftar_hari_libur = []


        let _cell_date_items = {} 
        /* 
            format: {
                row_id: {
                    wuku: "", 
                    dates: {col_id: date_detail}, 
                },
            }
         */
        

        var _today = this._TODAY;
        var _today_day = _today.getDate();
        var _today_month = _today.getMonth();
        var _today_year = _today.getFullYear();

        

        for (var i = 0; i < 6; i++) {
            
            for (var j = 0; j < 7; j++) {

                // Stop loop saat mencapai batas  maksimal tanggal
                if( no_date > max_date[_bulan]) {
                    break;
                }

                if(typeof _cell_date_items[row_tbl] === 'undefined')
                _cell_date_items[row_tbl] = {
                    'wuku': null,
                    'dates': {},
                }

                if (col_tbl === 7 || no_date <= max_date[_bulan] ) {
                    var _id_wuku = this.getPrimbonWuku(_tahun, _bulan + 1, no_date - 1);
                    _cell_date_items[row_tbl]['wuku'] = _id_wuku;
                }
                
                if (no_date <= max_date[_bulan]) {

                    if (col_tbl === 0) {
                        dino = 'Minggu';
                    } else if (col_tbl === 1) {
                        dino = 'Senin';
                    } else if (col_tbl === 2) {
                        dino = 'Selasa';
                    } else if (col_tbl === 3) {
                        dino = 'Rabu';
                    } else if (col_tbl === 4) {
                        dino = 'Kamis';
                    } else if (col_tbl === 5) {
                        dino = 'Jumat';
                    } else if (col_tbl === 6) {
                        dino = 'Sabtu';
                    }

                    hijriDate = HijriJS.gregorianToHijri(first_date.getFullYear(), first_date.getMonth() + 1, no_date);
                    pasarJava = this.pasaran(first_date.getFullYear(), first_date.getMonth() + 1, no_date);

                    var thnJawa = tahun_jawa[hijriDate.year - 1435 - Math.floor((hijriDate.year - 1435) / 8) * 8];

                    var _id_wuku_day = this.getPrimbonWuku(_tahun, _bulan + 1, no_date)

                    var _detail = 'Masehi : ' + no_date + ' ' + this.bulan[_bulan] + ' ' + _tahun + 
                            ';Tanggal Jawa : ' + hijriDate.day + ' ' + bulan_jawa[hijriDate.month - 1] + ' ' + (Number(hijriDate.year) + 512) + ' Ja' + 
                            ';Dino Pasaran : ' +  this.hari[col_tbl] + ' ' + pasarJava + 
                            ';Neptu : ' + this.neptu[dino][pasarJava] + 
                            ';Wuku : ' + this.namaWuku[_id_wuku_day] + ' (#' + (_id_wuku+1) + ')' +
                            ';Tahun Jawa : ' + thnJawa + 
                            ';Tanggal Hijriyah : ' + hijriDate.day + ' ' +
                                bulan_hijr[hijriDate.month - 1] + ' ' + hijriDate['year'] + ' H;';

                    var is_hari_ini = false
                    var is_hari_libur = false
                    var is_hari_jumat = false

                    if (col_tbl === 5)
                        is_hari_jumat = true;

                    // Setup today Cell
                    if (_tahun === _today_year && _bulan === _today_month && no_date === _today_day) {
                        is_hari_ini = true
                    }

                    // Setup Hari Libur
                    if (HariLiburNasional[no_date + ' ' + this.bulan[_bulan]]) {
                        is_hari_libur = true;
                        _detail += HariLiburNasional[no_date + ' ' + this.bulan[_bulan]] +';';
                        
                        _daftar_hari_libur.push( no_date + ' ' + this.bulan[_bulan] + 
                            ' : ' + HariLiburNasional[no_date + ' ' + this.bulan[_bulan]] );

                    } else if (HariLiburIslam[hijriDate.day + ' ' + bulan_jawa[hijriDate.month - 1]]) {
                        is_hari_libur = true;

                        
                        _detail += HariLiburIslam[hijriDate.day + ' ' + bulan_jawa[hijriDate.month - 1]] + ';';

                        _daftar_hari_libur.push( no_date + ' ' + this.bulan[_bulan] + 
                            ' : ' + HariLiburIslam[hijriDate.day + ' ' + bulan_jawa[hijriDate.month - 1]] );

                    } else if (ChineseNewYear['includes'](_tahun + '-' + String(_bulan + 1)['padStart'](2, '0') + '-' + String(no_date)['padStart'](2, '0'))) {
                        is_hari_libur = true;
                        
                        
                        _detail += 'Tahun Baru Imlek;';
                        
                        _daftar_hari_libur.push(no_date + ' ' + this.bulan[_bulan] + ' : Tahun Baru Imlek');
                        
                    } else if (HariNyepi['includes'](_tahun + '-' + String(_bulan + 1)['padStart'](
                            0x2, '0') + '-' + String(no_date)['padStart'](2, '0'))) {
                        is_hari_libur = true;
                        
                        _detail += 'Hari Raya Nyepi;';
                        
                        _daftar_hari_libur.push(no_date + ' ' + this.bulan[_bulan] + ' : Hari Raya Nyepi');

                    } else if (JumatAgung['includes'](_tahun + '-' + String(_bulan + 1)['padStart'](2, '0') + '-' + String(no_date)['padStart'](2, '0'))) {
                        is_hari_libur = true;
                        
                        _detail += 'Wafat Isa Al-Masih;';

                        _daftar_hari_libur.push(no_date + ' ' + this.bulan[_bulan] + ' : Wafat Isa Al-Masih');
                        
                    } else if (KenaikanIsa['includes'](_tahun + '-' + String(_bulan + 1)['padStart'](2, '0') + '-' + String(no_date)['padStart'](2, '0'))) {
                        is_hari_libur = true;
                        
                        
                        _detail += 'Kenaikan Isa Al-Masih;';
                        
                        _daftar_hari_libur.push(no_date + ' ' + this.bulan[_bulan] + ' : Kenaikan Isa Al-Masih');
                    
                    } else if (Waisak['includes'](_tahun + '-' + String(_bulan + 1)['padStart'](2, '0') + '-' + String(no_date)['padStart'](2, '0'))) {
                        is_hari_libur = true;
                        
                        
                        _detail += 'Waisak;';
                        
                        _daftar_hari_libur.push(no_date + ' ' + this.bulan[_bulan] + ' : Waisak');
                    
                    } else if(col_tbl === 0 ){ // Minggu

                        is_hari_libur = true; // khusus hari minggu 
                    }

                    _cell_date_items[row_tbl]['dates'][col_tbl] = {
                        no_tanggal: no_date, 
                        ket_tanggal: hijriDate.day + ' ' + pasarJava,
                        detail: _detail,
                        is_hari_libur: is_hari_libur,
                        is_hari_ini: is_hari_ini,
                        is_hari_jumat: is_hari_jumat,
                    }

                    this.setState({daftar_hari_libur: _daftar_hari_libur})

                }

                no_date++;
                col_tbl++;
                
                if (col_tbl === 7) {
                    col_tbl = 0;
                    row_tbl++;
                }
            }
                
            if (row_tbl > 7) {
                row_tbl = 0;
            };
        }
    
        this.setState({
            cell_date_items: _cell_date_items
        })

        // if ($('#harilibur .collection-item').length === 0) {
        //     $('#harilibur .collection').append('<li class="collection-item" style="list-style: none; color: #ccc"><i class="title">Tidak ada hari libur</i><a href="#!" class="secondary-content"></a></li>');
        // }
    
        // $('#catatan .collection').empty(); //$
        // var _catatan = Object.keys(localStorage);
    
        // function _0x47c77f(_0x23d53b, _0x585723) {
        //     var _0x283d62 = new Date(_0x23d53b).getTime();
        //     var _0x51dd11 = new Date(_0x585723).getTime();
        //     return _0x283d62 < _0x51dd11 ? -1 : _0x283d62 > _0x51dd11 ? 1 : 0;
        // }
    
        // _catatan.sort(_0x47c77f);
        // for (var i = 0; i < _catatan.length; i++) {
    
        //     var _c_tgl_split = _catatan[i].split('-');
        //     var _cat_tahun = _c_tgl_split[0];
        //     var _cat_bulan_i = Number(_c_tgl_split[1]) - 1;
        //     var _cat_hari = _c_tgl_split[2];
    
        //     if (_bulan === _cat_bulan_i && _tahun === _cat_tahun) {
        //         var _cat_bulan = String(_cat_bulan_i + 1)['padStart'](2, '0');
        //         var _0x5624ac = localStorage.getItem(_cat_tahun + '-' + _cat_bulan + '-' + _cat_hari).split(';');
    
                
        //         if (_0x5624ac.length > 1) {
        //             var _0xe3c524 = '';
        //             for (var _0x58fba6 = 0; _0x58fba6 < _0x5624ac.length; _0x58fba6++) {
        //                 _0xe3c524 += '<li>' + _0x5624ac[_0x58fba6] + '</li>';
        //             }
        //             $('#catatan .collection').append('<li class="collection-item" onclick="ctt_det("' + _cat_tahun + '-' + _cat_bulan + '-' + //$
        //                 _cat_hari + '")"><p><i>' + _cat_hari + ' ' + this.bulan[_cat_bulan_i] + ' ' +
        //                 _cat_tahun + '</i></p><ul>' + _0xe3c524 + '</ul></li>');
    
        //         } else {
        //             var _0x2b400a = '<li class="collection-item" onclick="ctt_det("' + _cat_tahun + '-' + _cat_bulan + '-' + _cat_hari + '")"><p><i>' + 
        //                 _cat_hari + ' ' + this.bulan[_cat_bulan_i] + ' ' + _cat_tahun + '</i><br>' +
                        
        //                 localStorage.getItem(_cat_tahun + '-' + _cat_bulan + '-' + _cat_hari).replace(';',
        //                     '') + '</p></li>';
    
        //             $('#catatan .collection').append(_0x2b400a) //$
        //         }
        //     }
        // }

        // $('#calendar').fadeIn('slow'); //$
    }

    nav_prev = () => {
        if( this.cal_bulan === 0 ){
            this.cal_bulan = 11;
            this.cal_tahun = this.cal_tahun - 1;
        } else {
            this.cal_bulan = this.cal_bulan -1;
        }
        this.generate_table();
    }

    nav_prev_year = () => {
        this.cal_tahun -= 1;
        this.generate_table();
    }

    nav_next = () => {
        if( this.cal_bulan === 11 ){
            this.cal_bulan = 1;
            this.cal_tahun = this.cal_tahun + 1;
        } else {
            this.cal_bulan += 1;
        }
        this.generate_table();
    }

    nav_next_year = () => {
        this.cal_tahun += 1;
        
        this.generate_table();
    }

    componentDidMount(){
        this.generate_table();
    }


    openDetailDate = (detail) => {
        var detail_text = detail
        var det = detail_text.slice(0, -1);
        var item_detail = det.split(';');
        
        var items_detail = '<h4>Detail Tanggal :</h4>';

        for (var i = 0; i < 7; i++) {
            items_detail += '<div>' + item_detail[i] + '</div>';
        }

        var lain_lain = '';
        if (item_detail.length > 7) {
            lain_lain += '<h4>Lainnya :</h4>';
            for (var ii = 7; ii < item_detail.length; ii++) {
                lain_lain += '<div>' + item_detail[ii] + '</div>';
            }
        }

        var result = items_detail + lain_lain;

        this.setState({detailedDate: result})
    }

    closeDetailDate = () => {
        this.setState({detailedDate: null})
    }


    render(){ 
        return(
<div>
        
    <div className="main_toolbar">
    {/* <div className="card"> */}
        {/* <div className="card-head"> */}
            <h2>Kalender Jawa</h2>
        {/* </div> */}
    {/* </div> */}
    </div>
    
    {/* <div id="kj"> */}
        {/* <div className="card"> */}
    <div id="calendar" className="calendar-java">
        
        <div className="calendar-header">
                
            <div className="cal-buttons">
                <button onClick={this.nav_prev_year} className="btn-arr">&laquo;</button>
                <button onClick={this.nav_prev} className="btn-arr">&lsaquo;</button>
            </div>
            <div className="cal-title">
                <div className="title">
                    {this.state.judul_kalender}
                </div>
                <span id='setbulan'></span>
                <div className="subtitle">{this.state.rentan_tgl_jawa}</div>
            </div>
            
            <div className="cal-buttons">
                <button onClick={this.nav_next} className="btn-arr">&rsaquo;</button>
                <button onClick={this.nav_next_year} className="btn-arr">&raquo;</button>
            </div>
            
        </div>
        <table className="cal_table tbl-hijr" border='1'>
            <thead>
                <tr className="row-days">
                    <th className="wuku" width="1">Wuku</th>
                    <th className="day" style={{"color": "#f44336"}}>Minggu</th>
                    <th className="day">Senin</th>
                    <th className="day">Selasa</th>
                    <th className="day">Rabu</th>
                    <th className="day">Kamis</th>
                    <th className="day" style={{"color": "#4caf50"}}>Jumat</th>
                    <th className="day">Sabtu</th>
                </tr>
            </thead>
            <tbody>
                {Object.keys(this.state.cell_date_items).map((x, i) =>
                <tr className={"row-"+i} key={i}>
                    
                    <td className="col-wuku">
                        <div className="wk">{this.namaWuku[this.state.cell_date_items[x].wuku]}</div>
                    </td>

                    {_.times(7, (i) => {
                        var det = this.state.cell_date_items[x].dates[i]

                        if( det ){
                            let _class = ['day', 'has_detail']
                            
                            if( det.is_hari_jumat)
                                _class.push('jumat')

                            if( det.is_hari_libur)
                                _class.push('holiday')

                            if( det.is_hari_ini)
                                _class.push('cell-today')

                            return(
                                
                                <td key={i} className={_class.join(' ')}
                                onClick={(e) => this.openDetailDate(det.detail, e)}>
                                    <div className="m-date">{det.no_tanggal}</div>
                                    <div className="h-date">{det.ket_tanggal}</div>
                                </td>
                                    
                                // <CellTanggal 
                                // className=""
                                // is_hari_jumat={a.is_hari_jumat}
                                //     is_hari_libur={a.is_hari_libur}
                                //     is_hari_ini={a.is_hari_ini}
                                //     no_tanggal={a.no_tanggal}
                                //     ket_tanggal={a.ket_tanggal}
                                //     detail={a.detail}
                                //     onClick={(e) => this.openDetailDate(a.detail, e)}
                                //     />
                            )
                        }
                        else return(<td key={i}></td>)
                    })}

                </tr>
                )}


                {/*                   
                {() => {
                    console.log("as", this.state.cell_date_items.length)
                    if( this.state.cell_date_items.length ){
                        this.state.cell_date_items[0]['dates'].keys().map((x, _) => {
                            console.log(x);
                            return (<div>xxxxxxxxxxx</div>)
                        })

                    }

                    let i = 2
                    return(
                        <tr className={"row-"+i} key={i}>

                        </tr>
                    )
                }}()
                    */}
            </tbody>
        </table>

        <div className="by">
            Kalender ini dibuat &amp; dikembangkan oleh <a target="_blank" href={this.state.developer_url} rel="noreferrer">{this.state.developer}</a>
        </div>
        
        <div className="hari-libur-container">
            <ul>
                {this.state.daftar_hari_libur.map((_, i) => (
                    <li className="collection-item" key={i}>
                        <span className="title" style={{color: "red"}}>{_}</span>
                    </li>
                ))}
            </ul>
        </div>
    </div>

        {/* </div> */}
    {/* </div> */}

    {this.state.detailedDate ? (
        <div className="modal" onClick={this.closeDetailDate}>
            <div className="modal-content" onClick={(e)=>e.stopPropagation()}>
                <span className="close" onClick={this.closeDetailDate}>&times;</span>
                <div dangerouslySetInnerHTML={{__html: this.state.detailedDate}}></div>
                <br />
            </div>
        </div>
    ) : (
        <div></div>
    )}
</div>
        )
    }


}

export default KalenderJawa;
